import React, { Component } from "react";
import { formValueSelector, Field } from "redux-form";
import { connect } from "react-redux";
import { Row } from "react-foundation";
import $ from "jquery";

import FormHeader from "../../components/FormHeader";
import InputError from "../../components/InputError";
import ThemeButton from "../../components/ThemeButton";
import SeparatingLine from "../../components/SeparatingLine";
import Tick from "components/Tick";
import Loading from "components/Loading";
import Image from "components/Image";
import SlickSlider from "components/SlickSlider";

import { updatePreviousSelection } from '../../actions';
import { getConservatoryExtras } from '../../actions';

class SelectColour extends Component {
    renderImage(value, id) {
        return (
            <div key={id}>
                <div className="slick-slide-image-container">
                    <Tick />
                    <Image src={value.externalImageUrl2} alt="" className="slick-slide-image" />
                </div>
                <p className={"slick-slide-title"}>{value.name}</p>
            </div>
        );
    }

    render() {
        let { types, input } = this.props;
        if ($.isEmptyObject(types)) {
            return <Loading />;
        }

        return (
            <div>
                <Row isColumn>
                    <SlickSlider values={types} selectedId={input.value} onDisplay={this.renderImage.bind(this)} onChange={input.onChange} />
                </Row>
                <InputError metas={this.props.meta} />
            </div>
        );
    }
}

class RoofForm extends Component {
    componentDidMount() {
        this.props.getConservatoryExtras(this.props.conservatoryId);
    }

    onSubmit(values) {
        this.props.updatePreviousSelection({
            ConservatoryRoofMaterialId: values.RoofMaterialId,
        });
        this.props.onSubmit(values);
    }

    render() {
        let {
            roofMaterial,
            previousPage
        } = this.props;

        return (
            <form className="TypeForm" onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}>
                <FormHeader title={"Pick your Roof Material"} subtitle={""}/>
                <SeparatingLine />
                <Field name="ConservatoryRoofMaterialId" component={SelectColour} types={roofMaterial} />
                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let conservatoryId = state.PreviousSelection.ConservatoryTypeId || 9;
    let roofMaterial = state.Conservatory.Extras.extras

    let valueSelector = formValueSelector("ConservatoryWizard");
    let conservatoryStyleId = valueSelector(state, "ConservatoryStyleId") || 1;
    let conservatoryRoomId = valueSelector(state, "ConservatoryId") || 25;

    return {
        conservatoryId,
        roofMaterial,
        conservatoryStyleId,
        conservatoryRoomId,
        previousSelection: state.PreviousSelection
    };
};

export default connect(mapStateToProps, { getConservatoryExtras, updatePreviousSelection })(RoofForm);



// WEBPACK FOOTER //
// ./src/containers/ConservatoryForm/RoofForm.js